import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcCoupon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.75 4A2.75 2.75 0 0 0 2 6.75v10.5A2.75 2.75 0 0 0 4.75 20h14.5A2.75 2.75 0 0 0 22 17.25V6.75A2.75 2.75 0 0 0 19.25 4zM17 18.5v-.2a.75.75 0 0 0-1.5 0v.2H4.75c-.69 0-1.25-.56-1.25-1.25V6.75c0-.69.56-1.25 1.25-1.25H15.5v.45a.75.75 0 0 0 1.5 0V5.5h2.25c.69 0 1.25.56 1.25 1.25v10.5c0 .69-.56 1.25-1.25 1.25zm0-9.7a.75.75 0 0 0-1.5 0v1.9a.75.75 0 0 0 1.5 0zm0 4.75a.75.75 0 0 0-1.5 0v1.9a.75.75 0 0 0 1.5 0z",
    clipRule: "evenodd"
  }));
}
var IcCoupon = createNolIcon(/*#__PURE__*/forwardRef(SvgIcCoupon));

export { IcCoupon as I };
